module.exports = __webpack_public_path__ + "static/media/ubication.c5569455.svg";